const STRING = {
  configuracoes: 'Configurações',
  enderecos: 'Endereços',
  odhen_interface: 'Odhen Interface',
  perifericos_DNS: 'Periféricos DNS',
  porta_balanca: 'Porta Balança',
  cores: 'Cores',
  primary_color: 'Cor primária',
  primary_light: 'Cor primária suave',
  primary_dark: 'Cor primária escura',
  header_color: 'Cor do cabeçalho',
  categorie_color: 'Cor das categorias',
  categorie_font_color: 'Cor da fonte das categorias',
  cart_color: 'Cor de fundo do carrinho',
  cart_font_color: 'Cor da fonte do carrinho',
  consumidor: 'Consumidor',
  tipo_consumidor: 'Tipo consumidor',
  codigo_loja: 'Código da loja',
  codigo_filial: 'Código da filial',
  dispositivo: 'Dispositivo',
  digitos_NSU: 'Quantidade de Digitos para NSU (Ex. 13 ou 20) vazio para automático',
  fechamento_automatico: 'Fechamento automático às 00:00?',
  emitir_fechamento_dia: 'Emitir fechamento do dia',
  modalidade_entrega: 'Modalidade de entrega',
  drive_throught: 'Drive Throught',
  comer_aqui: 'Comer Aqui',
  levar: 'Levar',
  parametrizacao_impressora: 'Parametrização de impressora',
  modelo: 'Modelo',
  porta_impressora: 'Porta da impressora',
  testar_impressora: 'Testar Impressora',
  bematech_Mp_20: 'Bematech Mp-20',
  epson_tm_T88IIP: 'Epson Tm-T88IIP',
  bematech_Mp_2100: 'Bematech Mp-2100',
  bematech_Mp_4000: 'Bematech Mp-4000',
  sewoo_chile: 'Sewoo - Chile',
  IBM_4610_colombia: 'IBM-4610 - Colômbia',
  bematech_MP_100_peru: 'Bematech MP-100 - Peru',
  daruma_DR600: 'Daruma DR600',
  epson_TM_U22A: 'Epson TM-U22A',
  daruma_DR700: 'Daruma DR700',
  epson_M244A: 'Epson M244A',
  zebra_Tlp_2844: 'Zebra Tlp 2844',
  bematech_MP_4200: 'Bematech MP-4200',
  epson_TM_T88V: 'Epson TM-T88V',
  epson_TM_T20: 'Epson TM-T20',
  sweda_SI_300S: 'Sweda SI-300S',
  elgin_I9: 'Elgin I9',
  epson_TM_T88IV_ethernet: 'Epson TM-T88IV Ethernet',
  elgin_kiosk_BKT681: 'Elgin Kiosk BKT681',
  bematech_MP_4200_compartilhada: 'Bematech MP-4200 - Compartilhada',
  custom_TG2480H: 'Custom TG2480H',
  gpos700: 'GPOS700',
  poynt: 'Poynt',
  gerais: 'Gerais',
  modo_TAP: 'Modo TAP?',
  modo_balanca: 'Modo balança Toledo Prix 3?',
  habilita_agruparnaimpressao: 'Habilita agrupar na impressao',
  habilita_modo_slim: 'Habilita modo slim',
  habilita_leitura_cod: 'Habilita leitura de código de barras dos produtos',
  habilita_acessibilidade: 'Habilita modo acessibilidade',
  habilita_modo_edicao: 'Habilita modo edição de cores',
  exibir_produtos_sem_foto: 'Exibir produtos sem foto?',
  exibir_a_partir_de: 'Exibir "a partir de" proximo aos preços?',
  exibe_botao_continuar_comprando: 'Exibe botão "Continuar Comprando" no carrinho?',
  cardapio_deve_expirar: 'Cardápio deve expirar de hora em hora?',
  utiliza_pager: 'Utiliza Pager?',
  altera_quantidade_adicionais: 'Permite alterar quantidade dos adicionais?',
  imprime_espelho_pedido: 'Imprime Pedido?',
  habilita_subgrupos: 'Habilita Subgrupos?',
  habilita_observacao_digitada: 'Habilita Observação Digitada?',
  exibe_itens_em_lista: 'Exibe itens do grupo promocional em lista?',
  minimiza_grupo_quantidade_maxima: 'Minimiza grupo ao atingir a quantidade máxima?',
  taxa_servico_fixa: 'Utiliza Taxa de Serviço Fixa?',
  diferenca_preco_minimo: 'Exibe diferença do preço mínimo?',
  pagamentos_homologacao: 'Pagamentos de Homologação? (Não Ativar em produção)',
  imagens_customizaveis: 'Imagens Customizáveis (jpg, png)',
  configurar: 'Configurar',
  usuario: 'Usuário',
  senha: 'Senha',
  entrar: 'Entrar',
  cancelar: 'Cancelar',
  version: 'Versão',
  confirmar: 'Confirmar',
  itens_pesaveis: 'Itens pesáveis',
  cancelamento_TEF: 'Cancelamento de TEF',
  NSU: 'NSU',
  nota_fiscal: 'Nota Fiscal',
  data: 'Data',
  valor: 'Valor',
  debito: 'Débito',
  credito: 'Crédito',
  pix_carteira_digital: 'PIX / Carteira Digital',
  voltar: 'Voltar',
  cancelar_TEF: 'Cancelar TEF',
  siga_instrucoes_pinpad: 'Siga as instruções no Pinpad',
  carrinho_vazio: 'Seu carrinho está vazio',
  total_caps: 'TOTAL',
  confirmar_pedido: 'Confirmar Pedido',
  reverter: 'Reverter',
  aplicar: 'Aplicar',
  esta_por_ai: 'Olá! Está por aí?',
  seu_pedido_te_espera: 'Seu pedido te espera',
  toque_para_voltar_ao_pedido: 'Toque para voltar ao seu pedido!',
  para_expirar: 'para expirar',
  pedido_para: 'Seu pedido é para:',
  viagem: 'Viagem',
  cadastrar_nova_senha: 'Cadastrar Nova Senha',
  repita_a_senha: 'Repita a Senha',
  aguarde: 'Aguarde',
  fechar: 'Fechar',
  alguma_observacao: 'Alguma Observação?',
  observacao_livre: 'Observação Livre',
  sem_observacao: 'Sem Observação',
  login_consumidor: 'Login Consumidor',
  login_sucesso: 'Login realizado com sucesso!',
  total_da_compra: 'Total da Compra:',
  saldo_familia: 'Saldo Família',
  total_familia: 'Total Família',
  saldo_apos_pagamento: 'Saldo após pagamento',
  saldo_cliente: 'Saldo do Cliente:',
  recarregar_saldo: 'Recarregar Saldo',
  confirmar_pagamento: 'Confirmar Pagamento',
  imprime_cupom_fiscal: 'Imprime Cupom Fiscal?',
  sim: 'Sim',
  nao: 'Não',
  enviar_por_e_mail: 'Enviar por E-mail',
  e_mail: 'E-mail',
  bloquear_desbloquear_produtos: 'Bloquear / Desbloquear produtos',
  a_partir_de: 'A partir de:',
  a_partir_de_gom: 'A partir de ',
  recarga_de_saldo: 'Recarga de Saldo',
  valor_da_recarga: 'Valor da Recarga',
  CPF: 'CPF',
  familia_de_produtos: 'Família de Produtos',
  selecione_forma_pagamento: 'Selecione a forma de pagamento:',
  personalize_seu_combo: 'Personalize seu combo:',
  carrinho: 'Carrinho',
  comanda: 'Comanda:',
  remover: 'Remover',
  adicionar_nova_pesagem: 'Adicionar nova pesagem',
  adicionar_mais_comandas: 'Adicionar mais comandas',
  total_dois_pontos: 'TOTAL:',
  continuar_comprando: 'Continuar Comprando',
  realizar_pagamento: 'Realizar Pagamento',
  digite_numero_comanda_ou_faca_leitura: 'Digite o número de sua comanda ou faça a leitura do código de barras',
  digite_valor_deseja_pagar: 'Digite o valor que deseja pagar',
  modo_acessibilidade: 'Modo Acessibilidade',
  digite_numero_comanda: 'Digite o número de sua comanda',
  identificacao_de: 'Identificação de ',
  comanda_minusculo: 'comanda',
  comanda_maiusculo: 'Comanda',
  digitar_com_teclado: 'Digitar com teclado',
  descricao: 'Descrição: ',
  confirmar_edicao: 'Confirmar Edição',
  adicionar_ao_carrinho: 'Adicionar ao Carrinho',
  comprar: 'COMPRAR',
  pagamento: 'Pagamento',
  informar_CPF_na_nota: 'Deseja informar CPF/CNPJ na nota fiscal?',
  CNPJ: 'CNPJ',
  nao_informar: 'Não Informar',
  CPF_CPNJ: 'CPF / CNPJ',
  todos_campos_obrigatorios: 'Todos os campos são obrigatórios',
  data_informada_formato: 'A data deve ser informada no formato DDMMAAAA',
  valor_informado_casas_decimais: 'O valor deve ser informado com no máximo duas casas decimais',
  selecione_tipo_cancelamento: 'Selecione um tipo de cancelamento',
  atingiu_limite_categoria: 'Você atingiu o limite de itens dessa categoria.',
  limite_minimo_categoria: 'Você atingiu o número mínimo de itens dessa categoria.',
  escolha: 'Escolha ',
  ate: 'até',
  opcao: ' opção',
  opcoes: ' opções',
  senhas_nao_sao_iguais: 'As senhas inseridas não são iguais',
  senha_cadastrada_sucesso: 'Senha Cadastrada com Sucesso!',
  nao_possivel_criar_nova_senha: 'Não foi possível criar uma nova senha para este usuário',
  houve_erro_ao_realizar_login: 'Houve um erro ao tentar realizar o login',
  erro_editar_consumidor_do_pedido: 'Erro ao editar o consumidor do pedido',
  preencha_e_mail_corretamente: 'Preencha o campo e-mail corretamente ou selecione outra opção de impressão',
  e_mail_digitado_nao_e_valido: 'O e-mail digitado não é válido',
  valor_informado_deve_ser_maior_que_zero: 'O valor informado deve ser maior que zero',
  selecione_familia_produtos: 'Selecione uma família de produtos',
  recarga_realizada_com_sucesso: 'Sua recarga foi realizada com sucesso!',
  operacao_negada_autorizador_tente_novamente: 'Operação negada pelo autorizador. <br><br> Verifique se a senha foi digitada corretamente, se o cartão possui saldo/limite e tente novamente',
  operacao_cancelada_operador_tente_novamente: 'Operação cancelada pelo operador. <br><br> Selecione a forma de pagamento e tente novamente',
  nao_possivel_realizar_recarga_valor_estornado: 'Não foi possível realizar sua recarga. <br><br> O valor pago já foi estornado.',
  qual_sabor_deseja: 'Qual sabor deseja?',
  posso_fazer_sugestao_tamanho: 'Posso fazer uma sugestão de tamanho?',
  posso_fazer_sugestao_combo: 'Posso fazer uma sugestão de combo?',
  leia_o_QR_code: 'Leia o QR Code',
  nao_ha_produto_padrao_pesagem_parametrizado: 'Não há um produto padrão para a pesagem parametrizado.',
  taxa_de_servico: 'Taxa de serviço: ',
  nome_dispositivo_obrigatorio: 'O nome do dispositivo é obrigatório!',
  endereco_interface_obrigatorio: 'O endereço da Odhen Interface é obrigatório!',
  endereco_perifericos_obrigatorio: 'O endereço do periféricos é obrigatório!',
  preenchimento_das_cores_obrigatorio: 'O preenchimento das cores é obrigatório!',
  cores_nao_podem_ser_iguais: 'As cores não podem ser iguais',
  parametros_aba_consumidor_faltando: 'Existem parametros da aba do consumidor que estão faltando',
  precisa_associar_totem_a_um_caixa: 'Você precisa associar o totem a um caixa',
  versao_interface: 'Versão da Odhen Interface ',
  incompativel_com_o_TAA_necessario_versao: ' incompatível com o TAA. Necessário versão ',
  ou_superior: ' ou superior',
  tamanho_imagem_menor_que_5MB: 'Tamanho da imagem deve ser menor do que 5MB',
  interface_nao_encontrada_404: '404 - Odhen Interface não encontrada, confira os arquivos de configuração no servidor.',
  sucesso_interface: 'Sucesso Odhen Interface </br>',
  senha_invalida: 'Senha inválida',
  realizar_login_outro_usuario: 'Realizar login como outro usuário?',
  deseja_realizar_logoff_usuario: 'Tem certeza de que deseja realizar logoff do usuário?',
  logado_como: 'Logado como',
  usuario_logado: 'Usuário Logado',
  escolha_forma_pagamento: 'Escolha uma forma de pagamento:',
  escolha_forma_pagamento_complementar: 'Escolha a forma de pagamento complementar:',
  realize_pagamento_principal: 'Realize o pagamento principal escolhido:',
  adicionar_taxa_servico: 'Gostaria de adicionar a taxa de serviço no valor de ',
  CPF_CNPJ_invalido: 'CPF/CNPJ inválido.',
  deseja_complementar: '<br><br>Deseja complementar ',
  com_outra_forma_pagamento: ' com outra forma de pagamento?',
  voce_precisa_selecionar_algum: 'Você precisa selecionar algum ',
  terminal_de_auto_atendimento: 'TAA - Terminal de Auto Atendimento',
  deseja_limpar_carrinho: 'Tem certeza que deseja limpar o carrinho?',
  certeza_que_deseja_remover: 'Tem certeza que deseja remover ',
  do_carrinho: ' do carrinho?',
  cliente_login_nao_e_o_mesmo_comanda: 'O cliente que realizou login não é o mesmo identificado na comanda---',
  valor_max_diario_familia: 'O valor máximo diário da família de produtos "',
  foi_excedido_aspas: '" foi excedido',
  seu_saldo_familia_de_produtos: 'Seu saldo para a família de produtos "',
  e_insuficiente: '" é insuficiente',
  valor_max_diario_forma_pagamento: 'O valor máximo diário desta forma de pagamento ',
  foi_excedido: ' foi excedido',
  saldo_insuficiente_completar_venda: 'Seu saldo é insuficiente para completar esta venda com a taxa de serviço',
  seu_saldo_esta_abaixo_de: 'Seu saldo está abaixo de ',
  seu_saldo: 'Seu saldo ',
  da_familia_de_produtos: 'da família de produtos ',
  das_familias_de_produtos: 'das famílias de produtos ',
  e: ' e ',
  esta_abaixo_de: ' está abaixo de ',
  nao_foi_possivel_configurar_pinpad: 'Não foi possível configurar o PinPad para iniciar a transação. Verifique se o periféricos está rodando',
  operacao_negada_pelo_autorizador: 'Operação negada pelo autorizador',
  problema_execucao_rotinas_pinpad: 'Problema na execução de alguma das rotinas no pinpad',
  cancelamento_TEF_finalizado_sucesso: 'Cancelamento de TEF finalizado com sucesso',
  configuracoes_faltantes_404: '404 - Existem configurações faltantes!',
  nao_foi_possivel_receber_XML: 'Não foi possível receber o XML da nota fiscal através da Odhen Interface',
  nao_foi_possivel_completar_venda: 'Não foi possível completar a venda. O valor pago foi estornado.',
  nao_possivel_completar_venda: 'Não foi possível completar a venda.',
  imagem_tela_de_espera: 'Imagem tela de espera',
  logo: 'Logo',
  produtos_sem_foto: 'Produtos sem foto',
  instrucoes_pager: 'Instruções pager',
  instrucoes_balanca: 'Instruções Balança',
  instrucoes_TAP: 'Instruções TAP',
  instrucoes_da_maquininha: 'Instruções da maquininha',
  instrucoes_da_impressora: 'Instruções da impressora',
  erro_de_impressora: 'Erro de impressora',
  erro_ao_salvar_venda: 'Erro ao salvar venda',
  erro_de_pinpad: 'Erro de Pinpad',
  erro_pinpad_2: 'Erro Pinpad 2',
  idiomas: 'Idiomas',
  idiomas_adicionais: 'Idiomas Adicionais',
  idioma_principal: 'Idioma Principal',
  portugues: 'Português',
  ingles: 'Inglês',
  espanhol: 'Espanhol',
  cupom_fiscal: 'Cupom Fiscal?',
  imprimir: 'Imprimir',
  nao_preciso_do_cupom: 'Não preciso do cupom',
  importar_exportar_configuracoes: 'Importar / Exportar Configurações',
  definir_configuracoes_como_padrao: 'Definir estas configurações como padrão',
  importar_configuracoes_servidor: 'Importar configurações do servidor',
  remover_opcoes_impressao_envio_cupom_fiscal: 'Remover opções de impressão e envio do cupom fiscal?',
  problema_nao_identificado_TEF: 'Ocorreu um problema não identificado com o TEF',
  pagamento_nao_disponivel_para_este_usuario: 'Esta forma de pagamento não está disponível para este usuário. <br><br> Selecione outra forma de pagamento.',
  nao_foi_possivel_configurar_pinpad_tente_novamente: 'Não foi possível configurar o PinPad para iniciar a transação. Verifique se o periféricos está rodando <br><br> Qualquer valor pago será estornado <br><br> Tente novamente',
  problema_execucao_rotinas_pinpad_tente_novamente: 'Problema na execução de alguma das rotinas no pinpad <br><br> Qualquer valor pago será estornado <br><br> Tente novamente',
  problema_nao_identificado_TEF_tente_novamente: 'Ocorreu um problema não identificado com o TEF <br><br> Qualquer valor pago será estornado <br><br> Tente novamente',
  utiliza_layout_alternativo: 'Utiliza layout alternativo?',
  proximo: 'Próximo',
  endereco_sitef: 'Endereço Sitef',
  video_nao_permitido: 'Arquivo de vídeo só é permitido na "Imagem da tela de espera"',
  configuracoes_salvas_para_caixa: 'Existem configurações salvas para o caixa',
  importar_configuracoes: '<br> Deseja importar as configurações?',
  deseja_importar_configuracoes_servidor: 'Deseja importar as configurações padrão do servidor?',
  deseja_definir_configurações_atuais_padrão: 'Deseja definir as configurações atuais deste TAA como padrão?',
  configuracoes_importadas_sucesso: 'As configurações do caixa foram importadas com sucesso!',
  falha_importar_config_caixa: 'Não foi possivel importar as configurações do caixa.',
  configuracao_definida_padrao: 'As configurações deste TAA foram definidas como padrão!',
  configuracao_padrao_importada: 'As configurações padrão foram importadas com sucesso!',
  falha_importar_config_padrao: 'Não foi possivel carregar as configurações do servidor.',
  utiliza_leitor_barras: 'Leitor de Código de Barras?',
  insira_numero_comanda: 'Insira o número da sua comanda:',
  insira_numero_pager: 'Insira o número do pager',
  por_favor_insira_comanda: 'Por favor, insira o número da sua comanda',
  escolha_um_grupo: 'O que você deseja?',
  concluir: 'Concluir',
  limpar: 'Limpar',
  pesquisar: 'Pesquisar: ',
  nao_ha_itens: 'Não há itens cacheados no TAA. <br> Para utilizar a função "Bloquear/Desbloquear" é necessário ter acessado o menu de produtos. Após carregar os produtos esta função estará disponível.',
  ultimo_fechamento_dia_sucesso: 'O último fechamento do dia foi realizado com sucesso. <br><br> Este caixa encontra-se bloqueado até o próximo dia.',
  fechamento_caixa_sucesso: 'O fechamento de caixa foi realizado com sucesso.',
  este_e_ultimo_fechamento_dia: 'Este é o último fechamento do dia?',
  caixa_bloqueado: 'Último fechamento do dia já foi realizado para este totem. <br><br> O caixa está bloqueado.',
  nao_possui_acesso_suficiente: 'Você não possui acesso suficiente para concluir esta operação',
  permissoes_nao_cadastradas: 'As permissões para este usuário não foram cadastradas. <br><br> Acesse a tela "Controle de Acesso TAA mobile" no Retail e realize o cadastro. <br><br> O TAA lê exclusivamente as permissões cadastradas naquela tela.',
  price_font_color: 'Cor da fonte do preço',
  preco_em_negrito: 'Habilita fonte do preço em negrito',
  reimpressao_cupom_fiscal: 'Reimpressão de Cupom Fiscal',
  visualizar: 'Visualizar',
  data_dois_pontos: 'Data: ',
  verificar_conexao: 'Verificar Conexão',
  pendente: 'Pendente',
  processando: 'Processando...',
  falha: 'Falha',
  concluido: 'Concluído',
  atualizar_informações_caixa: 'Atualizar Informações do Caixa',
  atualizar_recebimentos: 'Atualizar Tipos de Recebimentos',
  atualizar_imagens: 'Atualizar Imagens',
  aplicar_configuracoes: 'Aplicar Configurações',
  identificacao: 'Identificação',
  informe_celular: 'Por favor, insira seu número de celular:',
  nao_q_informar: 'Não quero informar',
  prox: 'Prox',
  utiliza_layout_gom: 'Utiliza Layout Gom',
  informe_cpf: 'Informe o CPF ou CNPJ',
  cancelar_pedido: 'Cancelar Pedido',
  voltar_cardapio: 'Voltar ao Cardápio',
  boas_noticias: 'Boas notícias!',
  voce_possui: 'Você possui ',
  utiliza_desconto: ' de desconto para utilizar. Deseja utilizar nesta compra?',
  desconto_aplicado: 'Desconto aplicado com sucesso!',
  valor_compra: 'Valor da compra: ',
  desconto: 'Desconto: ',
  total_dois_pontos_simples: 'Total: ',
  agora_nao: 'Agora não',
  aplicar_desconto: 'Aplicar desconto',
  continuar: 'Continuar',
  erro_valor_compra: 'Valor informado superior ao valor total da compra!',
  erro_valor_desconto: 'Valor informado superior ao valor disponível para desconto!',
  compra_concluida: 'Compra concluída.',
  aguarde_impressao: 'Aguarde a impressão do pedido!',
  pedido_impresso: 'Pedido impresso com sucesso!',
  falha_enviar_pedido: 'Falha ao enviar pedido.',
  pedido: 'Pedido ',
  enviado_aguarde: 'enviado. Aguarde...',
  aguardando_cupom: 'Aguardando cupom fiscal.',
  falha_cupom: 'Falha ao receber o cupom fiscal.',
  cupom_recebido: 'Cupom fiscal recebido com sucesso.',
  solicita_cancelamento: 'Solicitando o cancelamento da venda numero',
  venda: 'A venda',
  sera_cancelada: 'será cancelada!',
  finalizando_compra: 'Finalizando sua compra. Aguarde...',
  imprimindo_cupom: 'Imprimindo cupom fiscal. Aguarde...',
  cupom_impresso: 'Cupom fiscal impresso!',
  timeOut_inatividade: 'Timeout de inatividade (segundos)',
  timeOutInModal_inatividade: 'Timeout durante o modal de inatividade (segundos)',
  keyboard_clear: 'Limpar',
  keyboard_accept: 'Confirmar',
  posicione_o_codigo: 'Posicione o código',
  de_barras_comanda: 'de barras da comanda',
  no_leitor_abaixo: 'no leitor abaixo',
  ou_digite_numero_comanda: 'ou digite o número da comanda:',
  keyboard_space: 'Espaço',
  confira_seu_pedido: 'Confira seu pedido',
  interface_sem_conexao: 'Odhen interface sem conexão com o banco de dados.',
  voltar_tela_inicial: 'Voltando a tela inicial ',
  msg_pager: 'Você pode acompanhar seu pedido através do celular, apontando a câmera para o QRCODE ao lado.',
  msg_qrcode: 'Este QRCODE também é impresso ao final do seu cupom fiscal',
  voltar_agora: 'Voltar agora',
  menor_zero: 'O valor informado deve ser maior que 0',
  avanca_grupo_quantidade_maxima: 'Avança grupo automaticamente ao atingir a quantidade máxima?',
  demora_aguarde: 'Isso está demorando mais que o esperado. \n Por favor aguarde...'
}

const getString = function (key) {
  return STRING[key]
}

export default {
  getString: getString
}
